/**
 * Dialogue error types used across projects
 */

export const TIMEOUT_TYPE = 'TIMEOUT_TYPE';

export interface dialogueErrorBody {
  body: any; // JSX.Element or string
  buttons: dialogueErrorButton[];
  type?: string;
}

export interface dialogueErrorButton {
  text: string;
  cssClassNames?: string;
  redirectUrl?: string;
  action?: string;
}
